define(
  'SageDotCom/PatternAnimations/gradient',[
    "jquery",
    "ScrollMagic",
    "TweenMax",
    "AnimationPlugin",
    'SageDotCom/Utility/dimensions',
    "SageDotCom/Utility/consumableArray"
  ],
  function(
    $,
    ScrollMagic,
    TweenMax,
    AnimationPlugin,
    dimensions
  ) {
    var animateGradient = function animateGradient(gradient, ctrl) {
      return new ScrollMagic.Scene({
          triggerElement: gradient,
          triggerHook: 0,
          duration: dimensions.height
        }).setTween(gradient, 0.5, {
          backgroundPosition: '0% 100%'
        })
        // .addIndicators({name: "backgroundPosition - started"}) // add indicators (requires plugin)
        .addTo(ctrl);
    };

    return {
      init: function init(gradients, ctrl) {
        _toConsumableArray = function(arr) {
          if ($.isArray(arr)) {
            for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
              arr2[i] = arr[i];
            }
            return arr2;
          } else {

              var converted_array = [];
              var length = arr.length;

              for (var i = 0; i < length; i++) {
                  converted_array.push(arr[i]);
              }

              return converted_array;
          }
        };
        return [].concat(_toConsumableArray(gradients)).map(function(gradient) {
          return animateGradient(gradient, ctrl);
        });
      }
    };
  });

